<template>
    <div class="documentIndexPage">
       <iframe :src="iframeSrc" width="100%" height="100%" scrolling="auto" frameborder="0" class="trend-container2" id="iframe"></iframe>
    </div>
</template>

<script>
export default {
name: 'DocumentIndex',
    data() {
        return{
           iframeSrc: this.$axiosUrl.DocIframeSrc
        }
    },
    created() {
        this.$emit('isNavClick', '2')
        this.$actionBuryPointWay('','document-page','open','')
    },
    mounted() {
       
    },
    methods: {}
};
</script>

<style scoped lang="less">
    .documentIndexPage {
        height: 100vh;
        width: 100%;
        padding-top: 117px;
        // border: 1px solid #f00;
        // .trend-container2 {
        //     padding-top: 5px;
        // }
    }
</style>